export default __webpack_public_path__ + "static/media/_logo_no_bkg.a04481b0.png";